var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "eP7mc98DTXV1",
    viewBox: "0 0 110 110",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#eP7mc98DTXV2 {animation: eP7mc98DTXV2_c_o 2000ms linear infinite normal forwards}@keyframes eP7mc98DTXV2_c_o { 0% {opacity: 0.3} 50% {opacity: 1} 100% {opacity: 0.3}} #eP7mc98DTXV6_tr {animation: eP7mc98DTXV6_tr__tr 2000ms linear infinite normal forwards}@keyframes eP7mc98DTXV6_tr__tr { 0% {transform: translate(70.762719px,59.421573px) rotate(615deg)} 100% {transform: translate(70.762719px,59.421573px) rotate(975deg)}} #eP7mc98DTXV13_tr {animation: eP7mc98DTXV13_tr__tr 2000ms linear infinite normal forwards}@keyframes eP7mc98DTXV13_tr__tr { 0% {transform: translate(135.33781px,207.03926px) rotate(720deg);animation-timing-function: cubic-bezier(0.415,0.08,0.115,0.955)} 100% {transform: translate(135.33781px,207.03926px) rotate(532.987013deg)}} #eP7mc98DTXV14_tr {animation: eP7mc98DTXV14_tr__tr 2000ms linear infinite normal forwards}@keyframes eP7mc98DTXV14_tr__tr { 0% {transform: translate(11.12px,29.9px) rotate(-720deg);animation-timing-function: cubic-bezier(0.415,0.08,0.115,0.955)} 100% {transform: translate(11.12px,29.9px) rotate(-532.987013deg)}}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eP7mc98DTXV7-fill",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eP7mc98DTXV7-fill-0",
    offset: "0%",
    stopColor: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eP7mc98DTXV7-fill-1",
    offset: "100%",
    stopColor: "#010022"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eP7mc98DTXV2",
    transform: "translate(-27.900898 3.883)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8786,96.3332c-20.353,0-36.9112-16.5352-36.9112-36.8598s16.5582-36.8599,36.9112-36.8599c20.3534,0,36.9114,16.5352,36.9114,36.8599c0,20.3246-16.558,36.8598-36.9114,36.8598ZM126.676,46.9864h-2.836c-5.195-17.0099-20.717-29.5205-39.273-30.2387v-6.9247c1.9662-.6955,3.3769-2.56281,3.3769-4.76481C87.9439,2.26523,85.6755,0,82.8786,0c-2.7977,0-5.0652,2.26523-5.0652,5.05819c0,2.202,1.4106,4.06931,3.3768,4.76481v6.9247c-18.5557.7182-34.0781,13.2288-39.2725,30.2387h-2.8171c-3.1928,0-5.8048,2.6092-5.8048,5.7967v12.9405c0,3.1883,2.612,5.7967,5.8048,5.7967h2.6922c5.2113,17.7483,21.6277,30.7137,41.0858,30.7137c19.4584,0,35.8744-12.9654,41.0854-30.7137h2.712c3.206,0,5.83-2.6193,5.83-5.8212v-12.8916c0-3.2018-2.624-5.8211-5.83-5.8211Z",
    clipRule: "evenodd",
    fill: "#32c1c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.576065-1.446789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.12195,43.13389c0-1.86822,1.47426-3.3827,3.29286-3.3827s3.29286,1.51449,3.29286,3.3827c0,.23915-.02416.47251-.07011.69764h.07011v15.33696h-.00376c.00249.05281.00376.10594.00376.15937c0,1.82643-1.47426,3.30704-3.29286,3.30704s-3.29286-1.48061-3.29286-3.30704c0-.05343.00126-.10656.00376-.15937h-.00376v-15.33696h.07011c-.04595-.22513-.07011-.45848-.07011-.69764Z",
    transform: "matrix(1 0 0 0.844863-.652091 9.695679)",
    fill: "#44c7c7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "eP7mc98DTXV6_tr",
    transform: "translate(70.762719,59.421573) rotate(615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.12195,43.13389c0-1.86822,1.47426-3.3827,3.29286-3.3827s3.29286,1.51449,3.29286,3.3827c0,.23915-.02416.47251-.07011.69764h.07011v15.33696h-.00376c.00249.05281.00376.10594.00376.15937c0,1.82643-1.47426,3.30704-3.29286,3.30704s-3.29286-1.48061-3.29286-3.30704c0-.05343.00126-.10656.00376-.15937h-.00376v-15.33696h.07011c-.04595-.22513-.07011-.45848-.07011-.69764Z",
    transform: "scale(1,1.053848) translate(-71.41481,-41.60031)",
    fill: "#44c7c7",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.dd6a5a0e6c56b1b961f2167de512b138.svg";
export { ForwardRef as ReactComponent };